import {
    AnimationComponent,
    Animation,
    Component,
    Object3D,
    MeshComponent,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {SpecialPower} from '../special-power.js';
import {Puzzle} from '../puzzle.js';
import {Statistics} from '../statistics.js';
import {StatNames} from '../../enums/StatNames.js';
import {BlobPrefabs} from '../blob-prefabs.js';
import {BoardColor, BoardObject} from '../board-object.js';
import {SpecialBombType} from '../../enums/SpecialBombType.js';
import {WLUtils} from '../../utils/WLUtils.js';
import {FXPrefabs} from '../fx-prefabs.js';
import {SpawnScoreAfterSeconds} from '../spawn-score-after-seconds.js';
import {tempVec} from './tnt-power.js';
import {CupcakeGameRules} from '../rules/cupcake-game-rules.js';

export class CupcakePower extends SpecialPower {
    static TypeName = 'cupcake-power';
    static InheritProperties = true;

    @property.object({required: true})
    animatedObject!: Object3D;

    @property.animation()
    idle?: Animation;

    @property.string('CupcakeCollected')
    deathFX = 'CupcakeCollected';

    @property.string('ShowTextWithScore')
    scorePrefab = 'ShowTextWithScore';

    private _animation: AnimationComponent;
    private _boardObject: BoardObject;

    start(): void {
        this._animation = this.animatedObject.getComponent(AnimationComponent);

        this._animation.animation = this.idle.retarget([
            this.animatedObject,
            this.animatedObject,
        ]);

        this._animation.play();
    }

    override activate(puzzle: Puzzle, row: number, column: number): void {
        // do not call super, because there's no activation
    }

    override explode(puzzle: Puzzle, row: number, column: number) {
        const rules: CupcakeGameRules = Puzzle.instance.rules as CupcakeGameRules;

        rules.incrementNumberCupcakes();

        if (this.scorePrefab) {
            const targetCamera = this.engine.scene.activeViews[0].object;

            const cupcakeScore = FXPrefabs.instance.spawn(this.scorePrefab, targetCamera);
            this._boardObject.object.getPositionWorld(tempVec);
            cupcakeScore.setPositionWorld(tempVec);

            const cupcakeScoreParams = cupcakeScore.getComponent(SpawnScoreAfterSeconds);

            cupcakeScoreParams.setTextOfThis('');
            cupcakeScoreParams.setScoreToShow(
                rules.startingCupcakeWorth * rules.getNumCupcakes()
            );
            cupcakeScoreParams.setParent(targetCamera);
            cupcakeScoreParams.setColor(BoardColor.Pink);
            WLUtils.setActive(cupcakeScore, true);
        }

        // // called when this object explodes on the board.
        if (this.deathFX != null) {
            const fx = BlobPrefabs.instance.spawn(this.deathFX, null, true);
            const p = this._boardObject.object.getPositionWorld();
            const r = this._boardObject.object.getRotationWorld();
            fx.setPositionWorld(p);
            fx.setRotationWorld(r);
        }

        this.object.destroy();
    }

    override loaded(newParent: BoardObject) {
        this._boardObject = newParent;
    }

    override popped(puzzle: Puzzle, row: number, column: number) {
        puzzle.registerForRemoval(row, column);
    }
}
